module.exports = __webpack_public_path__ + "static/7-Cerca de La Puerta los Dos-b90f57f794d32859bf9724053a6ad654.jpg";